<template>
  <div class="card mb-3" style="min-height: 90vh;">
    <div class="card-body row">
      <Loading v-if="showLoading" />
      <div class="col-12">
        <div class="row m-0">
          <div class="col-9" style="display: flex; align-items: center;">
            <h3 class="ml-2 my-4">اطلاعات شارژ جهش</h3>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-3">
            <label> نام </label>
            <input class="form-control input" v-model="firstName" />
          </div>
          <div class="form-group col-md-3">
            <label>نام خانوادگی</label>
            <input class="form-control input" v-model="lastName" />
          </div>
          <div class="form-group col-md-3">
            <label>کد ملی</label>
            <input class="form-control input" v-model="nationalCode" />
          </div>
          <div class="from-group col-md-3">
            <label>وضعیت شارژ</label>
            <select class="form-control select" v-model="chargeWalletStatus">
              <option v-bind:value="false">همه</option>
              <option value="0">منتظر شارژ</option>
              <option value="1">شارژ موفق</option>
              <option value="2">شارژ ناموفق</option>
            </select>
          </div>
        </div>
        <div class="row mt-4" style="display: flex; justify-content: end">
          <!-- <div v-if="isSearched" class="col-md-3">
          <button class="btn btn-info btn-block" @click="getFullExelPath">
            دریافت فایل اکسل کل
          </button>
        </div>
        <div v-if="isSearched" class="col-md-3">
          <button class="btn btn-warning btn-block" @click="getExelPath">
            دریافت فایل اکسل
          </button>
        </div> -->
          <div class="col-md-3">
            <button class="btn btn-primary btn-block" @click="submit">
              <i class="si si-magnifier"></i>
              جستجو
            </button>
          </div>
        </div>
        <div class="alert alert-info mt-4 mb-0" v-if="!rows.length">
          <p class="mb-0">اطلاعاتی یافت نشد</p>
        </div>
        <hr v-if="rows.length" />
        <table class="table table-hover table-bordered mb-0" v-if="rows.length">
          <thead>
            <tr>
              <th>نام و نام خانوادگی</th>
              <th>کد ملی</th>
              <th>مبلغ شارژ (ریال)</th>
              <th>تاریخ انجام شارژ</th>
              <th>شناسه پیگیری انتقال وجه</th>
              <th>شناسه پیگیری شارژ کیف پول</th>
              <th>وضعیت</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="index">
              <td>{{ row.firstName }} {{ row.lastName }}</td>

              <td>{{ row.nationalCode }}</td>
              <td>{{ row.amount }}</td>
              <td>
                {{ row.chargeWalletStatus === 1 ? row.chargeAtShamsi : "-" }}
              </td>
              <td>
                {{ row.chargeWalletStatus === 1 ? row.d2dSerialNumber : "-" }}
              </td>
              <td>
                {{ row.chargeWalletStatus === 1 ? row.walletTraceNo : "-" }}
              </td>
              <td>
                {{
                  row.chargeWalletStatus === 2
                    ? row.chargeWalletStatusText +
                      " - " +
                      row.chargeErrorMessage
                    : row.chargeWalletStatusText
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <Pagination
          :pages="pages"
          :currentPage="currentPage"
          :prevPageMethod="(e) => currentPage--"
          :nextPageMethod="(e) => currentPage++"
          :changePageMethod="(e, page) => (currentPage = page)"
        />
        <div
          class="row mt-3"
          v-if="pages.length > 1"
          style="overflow-x: hidden;"
        >
          <div class="col-12" style="overflow-x: auto;">
            <ul class="pagination pagination-circled">
              <li class="page-item" v-if="currentPage > 1">
                <a class="page-link" href="#" v-on:click="currentPage--"
                  ><i class="icon ion-ios-arrow-forward"></i
                ></a>
              </li>
              <li
                :class="currentPage == page ? 'page-item active' : 'page-item'"
                v-for="(page, index) in pages"
                :key="index"
              >
                <div style="display: flex; flex-direction: row;">
                  <span
                    class="page-link ml-1"
                    v-if="page > pages[index - 1] + 1"
                  >
                    ...
                  </span>
                  <a
                    class="page-link"
                    href="#"
                    v-on:click="currentPage = page"
                    >{{ page }}</a
                  >
                </div>
              </li>
              <li class="page-item" v-if="pages.length != currentPage">
                <a class="page-link" href="#" v-on:click="currentPage++"
                  ><i class="icon ion-ios-arrow-back"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
        <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>

        <hr v-if="rows.length" />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../Partials/Pagination";

export default {
  name: "ChargeDetail",
  data() {
    return {
      rows: [],
      chargeRequestId: 0,
      showLoading: true,
      firstName: "",
      lastName: "",
      nationalCode: "",
      chargeWalletStatus: null,
      currentPage: 1,
      pages: [1],
      perPage: 10,
      count: 0,
      isSearched: false,
    };
  },
  watch: {
    currentPage(value) {
      this.currentPage = value;
      this.getData();
    },
    perPage(value) {
      if (this.count == 0) return;
      if (value) this.getData();
    },
  },
  methods: {
    handlePaginateArray(pagesCount) {
      let pagesArray = [1];
      if (pagesCount > 1) {
        if (this.currentPage > 2) pagesArray.push(this.currentPage - 1);
        if (this.currentPage > 1) pagesArray.push(this.currentPage);
        if (this.currentPage < pagesCount)
          pagesArray.push(this.currentPage + 1);
        const middle = Math.ceil(pagesCount / 2);
        if (middle > this.currentPage + 1 && middle < pagesCount - 2) {
          pagesArray.push(middle);
        }
        if (this.currentPage < pagesCount) pagesArray.push(pagesCount);
      }
      this.pages = pagesArray;
    },
    async getData() {
      this.showLoading = true;
      let url = `Jahesh/ChargeRequests/${this.chargeRequestId}/Details?page=${this.currentPage}&pageSize=${this.perPage}`;
      if (this.nationalCode) url += `&nationalCode=${this.nationalCode}`;
      if (this.firstName) url += `&firstName=${this.firstName}`;
      if (this.lastName) url += `&lastName=${this.lastName}`;
      if (this.chargeWalletStatus)
        url += `&chargeWalletStatus=${this.chargeWalletStatus}`;

      this.$api
        .get(url)
        .then(({ data }) => {
          if (data.status) {
            this.showLoading = false;
            this.rows = data.result.list;
            this.count = data.result.totalCount;
            let calcPages = Math.ceil(data.result.totalCount / this.perPage);
            this.handlePaginateArray(calcPages);
          }
          this.showLoading = false;
        })
        .catch(() => {
          this.showLoading = false;
          this.$swal({
            title: "ناموفق",
            icon: "error",
            text: " داده ای  یافت نشد ,لذا مجدد اقدام کنید!",
          });
        });
    },
    submit() {
      this.getData();
    },
  },
  created() {
    if (this.$route.params.id) {
      this.chargeRequestId = this.$route.params.id;
      this.getData();
    }
  },
};
</script>
